import React,{useEffect} from 'react'
import {Container,Row,Col,Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { getLogs } from '../../../actions/logsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Logs() {
    const { t } = useTranslation()
    const {logs} = useSelector(state=>state.logs)
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(getLogs())
    }, [dispatch, t])

    // Datatables
    const columns = [
        {
            name: t('logs.date'),
            cell: datos =>
                <div>
                    {datos.date.substr(8,2)+'/'+datos.date.substr(5,2)+'/'+datos.date.substr(0,4)+' - '+datos.date.substr(11,8)}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('logs.log'),
            cell: datos =>
                <div>
                    {datos.message}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        }
    ]

    return (      
        <Container>
            <Row className="text-left custom-card-header-list">
                <Col>
                    <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                    </Button>
                </Col>
                <Row className="text-center justify-content-center">
                    {logs 
                        ?
                            <CustomDataTable columns={columns} data={logs} />
                        :
                            <></>
                    }
                </Row>
            </Row>
        </Container>
    )
}